import { BuyerOptionProps } from '.';

import GenericText from './GenericText';


export default function Paragraph(props: BuyerOptionProps) {
  return <GenericText textFieldMaxLength={255} multiline={true} preserveRawText={true} {...props} />;
}
